<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-16 17:40:58
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-10-08 17:45:43
 * @name: 工单详情
 * @Description: 工单详情
 * @FilePath: \project\src\views\index\afterSale\waitApproveDeal\waitApproveDeal.vue
 * @Author: desktop
-->
<template>
  <div class="waitApproveDeal">
    <div class="container">
      <div class="head">
        <el-button size="mini" type="primary" @click="back">返回</el-button>
      </div>
      <div class="content">
        <div class="left">
          <div class="card">
            <div class="title">
              <font>用户信息</font>
            </div>
            <div class="agency">
              <div class="col">
                <font>琴行名称：</font>
                <font>{{ waitApproveDealView.agency.agency_name }}</font>
              </div>
              <div class="col">
                <font>琴行地址：</font>
                <font>{{ waitApproveDealView.agency.address }}</font>
              </div>
              <div class="col">
                <font>联系电话：</font>
                <font>{{ waitApproveDealView.agency.mobile }}</font>
              </div>
              <div class="col agency_receive_address">
                <font>退补货地址：</font>
                <font
                  >{{ waitApproveDealView.agency_receive_address.address }}({{
                    waitApproveDealView.agency_receive_address.name
                  }}
                  {{ waitApproveDealView.agency_receive_address.phone }})</font
                >
              </div>
            </div>
          </div>
          <div class="card">
            <div class="title">
              <font>问题信息</font>
            </div>
            <div class="problem-info">
              <el-alert
                v-if="waitApproveDealView.piano_fail_type === 'error'"
                class="piano-fail"
                title="未查询到琴号数据，请选择产品"
                type="error"
                :closable="false"
                :show-icon="true"
                @click.native="chooseProduct"
              >
              </el-alert>
              <el-alert
                v-if="waitApproveDealView.piano_fail_type === 'warning'"
                class="piano-fail"
                title="与ERP数据不一致，已覆盖"
                type="warning"
                :closable="false"
                :show-icon="true"
              >
              </el-alert>
              <div
                class="piano"
                v-if="
                  waitApproveDealView.piano_model ||
                  waitApproveDealView.piano_no ||
                  waitApproveDealView.piano_color
                "
              >
                <div class="col" v-if="waitApproveDealView.piano_model">
                  <font>型号：</font>
                  <font>{{ waitApproveDealView.piano_model }}</font>
                </div>
                <div class="col" v-if="waitApproveDealView.piano_no">
                  <font>琴号：</font>
                  <font
                    >{{ waitApproveDealView.piano_no
                    }}<i
                      class="el-icon-edit"
                      @click="editPianoNo"
                      v-if="
                        waitApproveDealView.musical !== '其它' &&
                        $route.query.run_act.split('|').includes('fangan') &&
                        Number($route.query.run_status) === 0
                      "
                    ></i
                  ></font>
                </div>
                <div class="col" v-if="waitApproveDealView.piano_color">
                  <font>颜色：</font>
                  <font>{{ waitApproveDealView.piano_color }}</font>
                </div>
              </div>
              <div
                class="piano_images"
                v-if="waitApproveDealView.piano_images.length > 0"
              >
                <font>图片: </font>
                <div class="piano_images_group">
                  <div
                    class="img-box"
                    v-for="(item, index) of waitApproveDealView.piano_images"
                    :key="item + index"
                  >
                    <img :src="item" />
                    <div
                      class="floating"
                      @click="
                        showPreview(waitApproveDealView.piano_images, index)
                      "
                    >
                      <img src="@/assets/icon/eye.png" />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="package_images"
                v-if="waitApproveDealView.package_images.length > 0"
              >
                <font>破损外包装图: </font>
                <div class="package_images_group">
                  <div
                    class="img-box"
                    v-for="(item, index) of waitApproveDealView.package_images"
                    :key="item + index"
                  >
                    <img :src="item" />
                    <div
                      class="floating"
                      @click="
                        showPreview(waitApproveDealView.package_images, index)
                      "
                    >
                      <img src="@/assets/icon/eye.png" />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="express_images"
                v-if="waitApproveDealView.express_images.length > 0"
              >
                <font>物流单据图: </font>
                <div class="express_images_group">
                  <div
                    class="img-box"
                    v-for="(item, index) of waitApproveDealView.express_images"
                    :key="item + index"
                  >
                    <img :src="item" />
                    <div
                      class="floating"
                      @click="
                        showPreview(waitApproveDealView.express_images, index)
                      "
                    >
                      <img src="@/assets/icon/eye.png" />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="problem-detail"
                v-if="!(waitApproveDealView.musical === '其它')"
              >
                <font class="problem-label">问题部位：</font>
                <div class="problem-content">
                  <div
                    class="problem-part"
                    v-for="itemX of waitApproveDealView.positions"
                    :key="itemX.key"
                  >
                    <div class="problem-name">
                      <font>{{ itemX.name }}</font>
                    </div>
                    <div class="problem-questions">
                      <div
                        class="questions-item"
                        v-for="(itemY, indexY) of itemX.questions"
                        :key="itemY.key"
                      >
                        <div class="questions-head">
                          <div class="questions-name">
                            <font class="label">{{ indexY + 1 }}、</font>
                            <font class="text">{{ itemY.name }}</font>
                          </div>
                          <div class="questions-desc">
                            <font class="label">问题描述：</font>
                            <font class="text">{{ itemY.desc }}</font>
                          </div>
                        </div>
                        <div class="questions-images">
                          <div
                            class="img-box"
                            v-for="(itemZ, indexZ) of itemY.files.split(',')"
                            :key="itemZ + indexZ"
                          >
                            <template v-if="itemZ.indexOf('video') > -1">
                              <div class="video-box">
                                <img
                                  :src="
                                    itemZ +
                                    '?x-oss-process=video/snapshot,t_0,f_jpg'
                                  "
                                  class="video"
                                />
                              </div>
                              <div
                                class="floating"
                                @click="
                                  showPreview(itemY.files.split(','), indexZ)
                                "
                              >
                                <img src="@/assets/icon/video-start.png" />
                              </div>
                            </template>
                            <template v-else>
                              <img :src="itemZ" class="image" />
                              <div
                                class="floating"
                                @click="
                                  showPreview(itemY.files.split(','), indexZ)
                                "
                              >
                                <img src="@/assets/icon/eye.png" />
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="other_question_des"
                v-if="waitApproveDealView.other_question_des"
              >
                <font>问题描述: </font>
                <div class="span">
                  <span>{{ waitApproveDealView.other_question_des }}</span>
                </div>
              </div>
              <div
                class="other_question_urls"
                v-if="waitApproveDealView.other_question_urls.length > 0"
              >
                <font>问题图片/视频: </font>
                <div class="other_question_urls_group">
                  <div
                    class="img-box"
                    v-for="(
                      item, index
                    ) of waitApproveDealView.other_question_urls"
                    :key="item + index"
                  >
                    <template v-if="item.indexOf('video') > -1">
                      <div class="video-box">
                        <img
                          :src="
                            item + '?x-oss-process=video/snapshot,t_0,f_jpg'
                          "
                          class="video"
                        />
                      </div>
                      <div
                        class="floating"
                        @click="
                          showPreview(
                            waitApproveDealView.other_question_urls,
                            index
                          )
                        "
                      >
                        <img src="@/assets/icon/video-start.png" />
                      </div>
                    </template>
                    <template v-else>
                      <img :src="item" class="image" />
                      <div
                        class="floating"
                        @click="
                          showPreview(
                            waitApproveDealView.other_question_urls,
                            index
                          )
                        "
                      >
                        <img src="@/assets/icon/eye.png" />
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="card"
            v-if="
              waitApproveDealView.plan &&
              waitApproveDealView.plan.resolve_way &&
              Number(waitApproveDealView.plan.resolve_way) !== 0
            "
          >
            <div class="card-head">
              <div class="card-head-item">
                <font>处理信息</font>
                <el-button type="text" size="mini" @click="seeDeal"
                  >处理方案查看</el-button
                >
              </div>
              <div class="card-head-item" v-if="checkCanEdit">
                <el-button
                  type="text"
                  size="mini"
                  @click="waitApproveDealView.toEdit()"
                  >修改</el-button
                >
              </div>
            </div>
            <div class="deal-info">
              <div class="row">
                <div class="col">
                  <font class="col-label">入库日期：</font>
                  <font class="col-value">{{ put_in_time }}</font>
                </div>
                <div class="col">
                  <font class="col-label">发货日期：</font>
                  <font class="col-value">{{ send_out_time }}</font>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <font class="col-label">处理方式：</font>
                  <font class="col-value">{{ dealway }}</font>
                </div>
                <div class="col">
                  <font class="col-label">具体解决措施：</font>
                  <font class="col-value">{{ resolve_plan }}</font>
                </div>
              </div>
              <div
                class="row"
                v-if="Number(waitApproveDealView.need_pay) === 0"
              >
                <div class="col">
                  <font class="col-label">成本核算金额</font>
                  <div class="col-value">
                    <span>无需收费</span>
                    <span
                      class="col-href"
                      @click="updateFeeSign"
                      v-if="
                        Number($route.query.run_status) === 0 &&
                        $route.query.run_act === 'cwdingjia'
                      "
                      >修改</span
                    >
                  </div>
                </div>
              </div>
              <div
                class="row"
                v-else-if="Number(waitApproveDealView.pay_user) === 2"
              >
                <div class="col">
                  <font class="col-label">费用收取对象：</font>
                  <div class="col-value">
                    <span>物流公司</span>
                    <span
                      class="col-href"
                      @click="updateFeeSign"
                      v-if="
                        Number($route.query.run_status) === 0 &&
                        $route.query.run_act === 'cwdingjia'
                      "
                      >修改</span
                    >
                  </div>
                </div>
              </div>
              <div
                class="fee-statistics"
                v-else-if="waitApproveDealView.is_confirm_fee"
              >
                <font class="fee-label">成本核算金额</font>
                <font class="fee-value">{{ total_fee }}元</font>
                <el-button type="text" size="mini" @click="seeFee"
                  >查看具体金额</el-button
                >
              </div>
            </div>
          </div>
          <div class="card" v-if="waitApproveDealView.payment_info">
            <div class="title">
              <font>缴费信息</font>
            </div>
            <div class="pay-info">
              <div class="row">
                <font class="label">缴费金额：</font>
                <font class="value"
                  >{{ waitApproveDealView.payment_info.money }}元</font
                >
              </div>
              <div class="row">
                <font class="label">缴费凭证：</font>
                <div class="attach">
                  <img :src="waitApproveDealView.payment_info.attach" />
                  <div
                    class="floating"
                    @click="
                      showBigImage(waitApproveDealView.payment_info.attach)
                    "
                  >
                    <img src="@/assets/icon/eye.png" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="card"
            v-if="!(!qa_remark && !qa_cause_analysis && !qa_deal_notice)"
          >
            <div class="qa">
              <div class="row" v-if="qa_remark">
                <font class="row-label">品质审批建议：</font>
                <font class="row-value">{{ qa_remark }}</font>
              </div>
              <div class="row" v-if="qa_cause_analysis">
                <font class="row-label">不合格原因分析：</font>
                <font class="row-value">{{ qa_cause_analysis }}</font>
              </div>
              <div class="row" v-if="qa_deal_notice">
                <font class="row-label">处理意见：</font>
                <font class="row-value">{{ qa_deal_notice }}</font>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="card">
            <div class="progress-list-container">
              <progress-list
                :progress="waitApproveDealView.run_process"
                :create_time="waitApproveDealView.create_time"
                :process_type="waitApproveDealView.process_type"
              ></progress-list>
            </div>
          </div>
        </div>
      </div>
      <div class="btnGroup" v-if="btn_group.length > 0">
        <div class="card">
          <template v-for="(item, index) in btn_group">
            <el-button
              :key="index"
              size="mini"
              :type="item.type === 'resolve' ? 'primary' : ''"
              @click="waitApproveDealView.btnClickHandler(item, $route.query)"
              >{{ item.text }}</el-button
            >
          </template>
        </div>
      </div>
    </div>
    <big-preview ref="bigPreview"></big-preview>
    <dialog-approve-normal
      ref="dialogApproveNormal"
      @finish="waitApproveDealView.approveFinish()"
    ></dialog-approve-normal>
    <dialog-approve-xuyingxiaozhuren
      ref="dialogApproveXuyingxiaozhuren"
      @finish="waitApproveDealView.approveFinish()"
    ></dialog-approve-xuyingxiaozhuren>
    <dialog-approve-pinzhisp
      ref="dialogApprovePinzhisp"
      @finish="waitApproveDealView.approveFinish()"
    ></dialog-approve-pinzhisp>
    <dialog-fee-show
      ref="dialogFeeShow"
      :origin="waitApproveDealView"
      @confirmFee="confirmFee"
      @quickConfirmFee="quickConfirmFee"
    ></dialog-fee-show>
    <dialog-fee-sign
      ref="dialogFeeSign"
      :origin="waitApproveDealView"
      @feeSignConfirm="confirmFee"
    ></dialog-fee-sign>
    <dialog-dealScheme-show ref="dialogDealSchemeShow"></dialog-dealScheme-show>
    <dialog-approve-xufuzongshenpi
      ref="dialogApproveXufuzongshenpi"
      @finish="waitApproveDealView.approveFinish()"
    ></dialog-approve-xufuzongshenpi>
    <dialog-approve-fuzongshenpi
      ref="dialogApproveFuzongshenpi"
      @finish="waitApproveDealView.approveFinish()"
    ></dialog-approve-fuzongshenpi>
    <dialog-evaluate ref="dialogEvaluate"></dialog-evaluate>
    <big-image ref="bigImage"></big-image>
    <product-choose
      ref="productChoose"
      @choose="chooseHandler"
    ></product-choose>
  </div>
</template>
<script>
import waitApproveDealView from "./waitApproveDeal.view.js";
import progressList from "@/components/public/progress-list.vue";
import bigPreview from "@/components/public/big-preview.vue";
import dialogApproveNormal from "@/components/afterSale/dialog-approve-normal.vue";
import dialogApproveXuyingxiaozhuren from "@/components/afterSale/dialog-approve-xuyingxiaozhuren.vue";
import dialogApprovePinzhisp from "@/components/afterSale/dialog-approve-pinzhisp.vue";
import dialogFeeShow from "@/components/afterSale/dialog-fee-show.vue";
import dialogFeeSign from "@/components/afterSale/dialog-fee-sign";
import dialogDealSchemeShow from "@/components/afterSale/dialog-dealScheme-show.vue";
import dialogApproveXufuzongshenpi from "@/components/afterSale/dialog-approve-xufuzongshenpi.vue";
import dialogApproveFuzongshenpi from "@/components/afterSale/dialog-approve-fuzongshenpi.vue";
import dialogEvaluate from "@/components/afterSale/dialog-evaluate.vue";
import bigImage from "@/components/public/big-image.vue";
import productChoose from "@/components/afterSale/product-choose.vue";
import { debounceation } from "@/utils/decorator.js";
import { Loading } from "element-ui";

export default {
  name: "indexWaitApproveDeal",
  components: {
    progressList,
    bigPreview,
    dialogApproveNormal,
    dialogApproveXuyingxiaozhuren,
    dialogFeeShow,
    dialogFeeSign,
    dialogDealSchemeShow,
    dialogApprovePinzhisp,
    dialogApproveXufuzongshenpi,
    dialogApproveFuzongshenpi,
    dialogEvaluate,
    bigImage,
    productChoose,
  },
  data() {
    return {
      waitApproveDealView: {},
    };
  },
  computed: {
    // 按钮组
    btn_group() {
      let btn_group = [];
      if (Number(this.$route.query.run_status) === 0) {
        btn_group =
          this.waitApproveDealView.afterSale_detail_btn?.find(
            (x) => x.key === this.$route.query.run_act
          )?.btn ?? [];
      } else if (Number(this.waitApproveDealView.evaluate_status) === 1) {
        btn_group = [
          {
            type: "resolve",
            text: "查看评价",
            value: "",
          },
        ];
      }
      return btn_group;
    },
    // 入库日期
    put_in_time() {
      return this.waitApproveDealView?.plan?.put_in_time?.substr(0, 10) ?? "";
    },
    // 发货日期
    send_out_time() {
      return this.waitApproveDealView?.plan?.send_out_time?.substr(0, 10) ?? "";
    },
    // 处理方式
    dealway() {
      return (
        this.waitApproveDealView?.issueService?.getIssueConfigText?.(
          "resolve_ways",
          this.waitApproveDealView?.plan?.resolve_way ?? 0
        ) ?? ""
      );
    },
    // 具体解决措施
    resolve_plan() {
      return this.waitApproveDealView?.plan?.resolve_plan ?? "";
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 费用
     */
    fee() {
      return this.waitApproveDealView?.fee ?? [];
    },
    // 金额总和
    total_fee() {
      let fees = this.fee;
      let totalFee = 0;
      for (let x of fees) {
        if (x.type === "fee") {
          totalFee = Number(totalFee) + Number(x.value);
        }
      }
      return totalFee;
    },
    // 可否编辑
    checkCanEdit() {
      return (
        Number(this.$route.query.run_status) === 0 &&
        this.waitApproveDealView.issueService.checkCanEdit(
          this.$route.query.run_act
        )
      );
    },
    qa_remark() {
      return this.waitApproveDealView?.quality_verify?.remark ?? "";
    },
    qa_cause_analysis() {
      return this.waitApproveDealView?.quality_verify?.cause_analysis ?? "";
    },
    qa_deal_notice() {
      return this.waitApproveDealView?.quality_verify?.deal_notice ?? "";
    },
  },
  created() {
    this.waitApproveDealView = new waitApproveDealView(this);
    this.waitApproveDealView.getDetail();
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 预览
     * @param {Array} urls 地址数组
     * @param {Number} index 索引
     */
    @debounceation(300)
    showPreview(urls, index) {
      this.$refs.bigPreview.open(urls, index);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击查看具体金额
     */
    @debounceation(300)
    seeFee() {
      this.$refs.dialogFeeShow.open(this.fee);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 财务修改费用
     */
    @debounceation(300)
    updateFeeSign() {
      this.$refs.dialogFeeSign.open(this.fee);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击处理方案查看
     */
    @debounceation(300)
    seeDeal() {
      this.$refs.dialogDealSchemeShow.open(this.waitApproveDealView.plan);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 费用确认(财务)
     * @param {Object} obj 费用信息
     */
    @debounceation(300)
    confirmFee(obj) {
      this.waitApproveDealView.need_pay = obj.need_pay;
      this.waitApproveDealView.pay_user = obj.pay_user;
      this.waitApproveDealView.fee = obj.fee;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 费用确认(售后)
     * @param {Object} obj 费用信息
     */
    @debounceation(300)
    quickConfirmFee(obj) {
      this.waitApproveDealView.editFee(obj);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 查看大图
     * @param {String} path 图片地址
     */
    @debounceation(300)
    showBigImage(path) {
      this.$refs.bigImage.open(path);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 选择产品
     */
    @debounceation(300)
    chooseProduct() {
      this.$refs.productChoose.open(this.waitApproveDealView.piano_model);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 选择产品回调
     * @param {Object} item 产品信息
     */
    chooseHandler(item) {
      const loading = Loading.service({ text: "提交中..." });
      this.waitApproveDealView.issueService
        .editIssue({
          issue_id: this.$route.query.issue_id,
          piano_no: this.waitApproveDealView.piano_no,
          piano_model: item.model,
          piano_color: item.color,
          product_id: item.product_id,
        })
        .then((res) => {
          this.waitApproveDealView.piano_model = item.model;
          this.waitApproveDealView.piano_color = item.color;
          this.waitApproveDealView.piano_fail_type = "";
          this.$refs.productChoose.close();
        })
        .finally(() => {
          loading.close();
        });
    },
    editPianoNo() {
      this.$prompt("请输入琴号", "修改琴号", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (!value) {
            this.$message.error("输入琴号不能为空");
            return;
          }
          this.waitApproveDealView.piano_no = value;
          this.waitApproveDealView.getPianoInfo();
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.waitApproveDeal {
  width: 100%;
  height: 100%;
  .container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 10px;
    @extend .et-flex-column-normal;
    .head {
      flex-shrink: 0;
      margin-bottom: 10px;
      @extend .et-flex-start;
    }
    .content {
      width: 100%;
      flex: 1;
      @extend .et-flex-normal;
      align-items: stretch;
      overflow-y: auto;
      padding: 5px;
      box-sizing: border-box;
      .left {
        flex: 1;
        @extend .et-flex-column-normal;
      }
      .right {
        margin-left: 10px;
        width: 330px;
        flex-shrink: 0;
        @extend .et-flex-column-normal;
      }
      .card {
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0 !important;
        }
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        border-radius: $Vars-border-radius-normal;
        box-shadow: $Vars-boxShadow-normal;
        .title {
          width: 100%;
          padding: 10px 0;
          font-size: $Vars-font-miniTitle-size;
          font-weight: bold;
          border-bottom: 1px solid $Vars-border-second-color;
        }
        .card-head {
          width: 100%;
          padding: 10px 0;
          font-size: $Vars-font-miniTitle-size;
          border-bottom: 1px solid $Vars-border-second-color;
          @extend .et-flex-spacebetween;
          .card-head-item {
            @extend .et-flex-start;
            font {
              margin-right: 10px;
              font-weight: bold;
            }
          }
        }
        .agency {
          width: 100%;
          padding: 10px 0;
          font-size: $Vars-font-miniContent-size;
          @extend .et-flex-normal;
          .col {
            width: calc(100% / 3);
            padding: 5px 0;
            line-height: $Vars-font-tight-lineHeight;
            @extend .et-flex-normal;
            font {
              &:first-child {
                flex-shrink: 0;
              }
              &:nth-child(2) {
                flex: 1;
              }
            }
            &.agency_receive_address {
              width: 100%;
            }
          }
        }
        .problem-info {
          width: 100%;
          padding: 10px 0;
          font-size: $Vars-font-miniContent-size;
          @extend .et-flex-column-normal;
          .piano {
            width: 100%;
            @extend .et-flex-normal;
            .col {
              flex: 1;
              line-height: $Vars-font-tight-lineHeight;
              @extend .et-flex-normal;
              font {
                &:first-child {
                  flex-shrink: 0;
                }
                &:nth-child(2) {
                  flex: 1;
                  .el-icon-edit {
                    line-height: $Vars-font-tight-lineHeight;
                    font-size: 13px;
                    margin: 0 5px;
                    color: $Vars-normal-color;
                    @extend .et-clickElement;
                  }
                }
              }
            }
          }
          .piano-fail {
            margin: 10px 0;
            @extend .et-clickElement;
          }
          .piano_images,
          .package_images,
          .express_images,
          .other_question_des,
          .other_question_urls {
            width: 100%;
            padding: 10px 0;
            @extend .et-flex-normal;
            font {
              margin: 5px 10px 0 0;
              flex-shrink: 0;
            }
            .span {
              margin-top: 5px;
              flex: 1;
            }
            .piano_images_group,
            .package_images_group,
            .express_images_group,
            .other_question_urls_group {
              flex: 1;
              @extend .et-flex-normal;
              .img-box {
                margin: 5px;
                width: 100px;
                height: 100px;
                border-radius: $Vars-border-radius-normal;
                border: 1px solid $Vars-border-fourth-color;
                overflow: hidden;
                position: relative;
                .video-box {
                  width: 100px;
                  height: 100px;
                  background: rgb(229, 229, 229);
                  @extend .et-flex-center;
                  position: relative;
                  .video {
                    width: 100px;
                    height: 100px;
                  }
                }
                img {
                  width: 100px;
                  height: 100px;
                }
                .floating {
                  display: none;
                }
                &:hover {
                  .floating {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100px;
                    height: 100px;
                    background: rgba(0, 0, 0, 0.3);
                    z-index: 1;
                    @extend .et-clickElement;
                    @extend .et-flex-center;
                    img {
                      width: 20%;
                      height: 20%;
                    }
                  }
                }
              }
            }
          }
          .problem-detail {
            width: 100%;
            @extend .et-flex-normal;
            .problem-label {
              margin-right: 10px;
              flex-shrink: 0;
            }
            .problem-content {
              flex: 1;
              @extend .et-flex-column-normal;
              .problem-part {
                width: 100%;
                margin-bottom: 10px;
                @extend .et-flex-normal;
                .problem-name {
                  width: calc(#{$Vars-font-miniContent-size} * 8);
                  @extend .et-flex-normal;
                  flex-wrap: nowrap;
                  margin-right: 5px;
                  &::before {
                    content: "";
                    width: 4px;
                    height: 4px;
                    border-radius: 4px;
                    background: $Vars-normal-color;
                    margin-top: 6px;
                    margin-right: 10px;
                    flex-shrink: 0;
                  }
                }
                .problem-questions {
                  flex: 1;
                  @extend .et-flex-column-normal;
                  .questions-item {
                    width: 100%;
                    padding-bottom: 10px;
                    @extend .et-flex-normal;
                    .questions-head {
                      width: 100%;
                      @extend .et-flex-normal;
                      .questions-name {
                        flex: 1;
                        @extend .et-flex-normal;
                        .label {
                          flex-shrink: 0;
                        }
                        .text {
                          flex: 1;
                        }
                      }
                      .questions-desc {
                        flex: 2;
                        @extend .et-flex-normal;
                        .label {
                          flex-shrink: 0;
                        }
                        .text {
                          flex: 1;
                        }
                      }
                    }
                    .questions-images {
                      width: 100%;
                      padding: 10px 0;
                      @extend .et-flex-normal;
                      .img-box {
                        margin: 5px;
                        width: 100px;
                        height: 100px;
                        border: 1px solid $Vars-border-fourth-color;
                        border-radius: $Vars-border-radius-normal;
                        overflow: hidden;
                        position: relative;
                        .video-box {
                          width: 100px;
                          height: 100px;
                          background: rgb(229, 229, 229);
                          @extend .et-flex-center;
                          position: relative;
                          .video {
                            width: 100px;
                            height: 100px;
                          }
                        }
                        .image {
                          width: 100px;
                          height: 100px;
                        }
                        &:hover {
                          .floating {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100px;
                            height: 100px;
                            background: rgba(0, 0, 0, 0.3);
                            z-index: 1;
                            @extend .et-clickElement;
                            @extend .et-flex-center;
                            img {
                              width: 20%;
                              height: 20%;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        .pay-info {
          width: 100%;
          padding: 10px 0;
          font-size: $Vars-font-miniContent-size;
          @extend .et-flex-column-normal;
          .row {
            flex: 1;
            margin-top: 10px;
            &:first-child {
              margin-top: 0 !important;
            }
            @extend .et-flex-normal;
            .label {
              flex-shrink: 0;
            }
            .value {
              flex: 1;
            }
            .attach {
              width: 180px;
              height: 180px;
              position: relative;
              img {
                width: 180px;
                height: 180px;
              }
              .floating {
                display: none;
              }
              &:hover {
                .floating {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 180px;
                  height: 180px;
                  background: rgba(0, 0, 0, 0.3);
                  z-index: 1;
                  @extend .et-clickElement;
                  @extend .et-flex-center;
                  img {
                    width: 20%;
                    height: 20%;
                  }
                }
              }
            }
          }
        }
        .deal-info {
          width: 100%;
          padding: 10px 0;
          @extend .et-flex-column-normal;
          .row {
            width: 100%;
            padding: 5px 0;
            @extend .et-flex-normal;
            font-size: $Vars-font-miniContent-size;
            .col {
              &:nth-child(1) {
                flex: 1;
              }
              &:nth-child(2) {
                flex: 2;
              }
              @extend .et-flex-normal;
              .col-label {
                margin-right: 10px;
                flex-shrink: 0;
              }
              .col-value {
                flex: 1;
                .col-href {
                  margin-left: 10px;
                  color: $Vars-normal-color;
                  @extend .et-clickElement;
                }
              }
            }
          }
          .fee-statistics {
            width: 100%;
            padding: 5px 0;
            @extend .et-flex-start;
            font-size: $Vars-font-miniContent-size;
            .fee-label {
              margin-right: 10px;
              flex-shrink: 0;
            }
            .fee-value {
              padding: 0 20px;
              width: 150px;
              text-align: right;
            }
          }
        }
        .qa {
          width: 100%;
          padding: 10px 0;
          @extend .et-flex-column-normal;
          .row {
            width: 100%;
            padding: 5px 0;
            @extend .et-flex-normal;
            font-size: $Vars-font-miniContent-size;
            .row-label {
              width: 110px;
              margin-right: 10px;
              flex-shrink: 0;
            }
            .row-value {
              flex: 1;
              white-space: pre-line;
              line-height: $Vars-font-tight-lineHeight;
            }
          }
        }
        .progress-list-container {
          width: 100%;
          padding: 20px 0;
        }
      }
    }
    .btnGroup {
      flex-shrink: 0;
      margin: 10px 0;
      width: 100%;
      .card {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        border-radius: $Vars-border-radius-normal;
        box-shadow: $Vars-boxShadow-normal;
        @extend .et-flex-center;
      }
    }
  }
}
</style>